import EditIcon from "@mui/icons-material/Edit";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Link from "@mui/material/Link";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import frequency from "../../../assets/img/frequency.svg";
import { isOnWorkspaceConfigurationRoute } from "../../../utils/navigationUtils";
import { EditWorkspaceButton } from "../../../components/Workspace/EditWorkspaceButton";

interface Props {
  onClick: () => void;
  isCard?: boolean;
  cardTitle?: string;
  isForTable?: boolean;
}

export function InsufficientInfo(props: Props) {
  if (props.isCard) {
    const isInWorkspaceConfigRoute = isOnWorkspaceConfigurationRoute(
      window.location.pathname
    );
    return (
      <Box
        id="no-data-available-card-message"
        className="insufficient-info-card"
        minHeight="130px"
        minWidth="300px"
        padding="20px 30px 25px 20px"
        display="flex"
        borderRadius="7px"
        flexDirection="column"
        border="solid 1px #eceff1"
        bgcolor="#fafafa"
        gap="16px"
        boxSizing="border-box"
        sx={{
          "&:hover": {
            bgcolor: "#eceff1",
          },
        }}
      >
        <Box display="flex" justifyContent="space-between" position="relative">
          <Typography variant="h2" sx={{ color: "#757575", mt: "10px" }}>
            {props.cardTitle}
          </Typography>
          {!isInWorkspaceConfigRoute && (
            <EditWorkspaceButton
              onClick={props.onClick}
              top="-10px"
              right="-21px"
            />
          )}
        </Box>
        <Stack spacing={0.5}>
          <Typography variant="h3">
            {!isInWorkspaceConfigRoute
              ? "Insufficient information"
              : "Please update the definition"}
          </Typography>
          {!isInWorkspaceConfigRoute && (
            <Typography variant="body2">
              Please update the project{" "}
              <Link
                variant="body2"
                underline="none"
                onClick={props.onClick}
                sx={{ cursor: "pointer" }}
                aria-label="Configure project"
              >
                configuration
              </Link>
              .
            </Typography>
          )}
        </Stack>
      </Box>
    );
  }

  if (props.isForTable) {
    return (
      <Box
        id="no-chart-data-available-message"
        display="flex"
        height="100%"
        alignItems="center"
        justifyContent="center"
        sx={{
          cursor: "default",
        }}
        padding="8px"
      >
        <Box display="flex" flexDirection="row" gap={1}>
          <img
            src={frequency}
            alt="insufficient-information"
            width={100}
            height={100}
            style={{
              alignSelf: "center",
            }}
          />
          <Box
            display="flex"
            marginTop={1.5}
            gap={0.5}
            flexDirection="column"
            alignItems="flex-start"
          >
            <Typography variant="h5">Insufficient Information</Typography>
            <Typography variant="body2">
              Please update the project configuration.
            </Typography>
            <Button
              variant="contained"
              size="small"
              color="secondary"
              startIcon={<EditIcon />}
              onClick={props.onClick}
            >
              edit configuration
            </Button>
          </Box>
        </Box>
      </Box>
    );
  }

  return (
    <Box
      id="no-data-available-message"
      data-testid="workspace-insufficient-info-message"
      display="flex"
      height="100%"
      alignItems="center"
      justifyContent="center"
      bgcolor="#edeff1"
    >
      <Stack spacing={1}>
        <img
          src={frequency}
          alt="insufficient-information"
          width={100}
          height={100}
          style={{
            alignSelf: "center",
          }}
        />
        <Typography variant="h3" alignSelf="center">
          Insufficient Information
        </Typography>
        <Typography variant="body1" alignSelf="center">
          Please update the workspace configuration.
        </Typography>
        <Button
          data-testid="workspace-insufficient-info-edit-btn"
          variant="contained"
          size="small"
          color="secondary"
          startIcon={<EditIcon />}
          onClick={props.onClick}
          sx={{
            alignSelf: "center",
          }}
        >
          edit configuration
        </Button>
      </Stack>
    </Box>
  );
}
